import { RouteRecordRaw } from "vue-router";

import {
	newReservationPlannerSessionPath,
	reservationPlannerArchivePath,
	reservationPlannerPath,
	reservationPlannerSessionPath
} from "@/js/utils/paths";

export const routes: RouteRecordRaw[] = [
	{
		path: reservationPlannerPath(),
		name: "ReservationPlannerSessions",
		component: () => import("../ReservationPlannerSessions.vue"),
		meta: {
			title: "Reservations"
		}
	},
	{
		path: newReservationPlannerSessionPath(),
		name: "NewReservationPlannerSession",
		component: () => import("../NewReservationPlannerSession.vue"),
		meta: {
			title: "New session",
			parentName: "ReservationPlannerSessions"
		}
	},
	{
		path: reservationPlannerArchivePath(),
		name: "ReservationPlannerArchive",
		component: () => import("../ReservationPlannerArchive.vue"),
		meta: {
			title: "Archive",
			parentName: "ReservationPlannerSessions"
		}
	},
	{
		path: reservationPlannerSessionPath(":id"),
		name: "ReservationPlannerSession",
		component: () => import("../ReservationPlannerSession.vue"),
		beforeEnter({ path, params }) {
			const id = (params.id ?? "") as string;

			if (path === reservationPlannerSessionPath(id)) {
				return {
					path: reservationPlannerSessionPath(id, "conflicts")
				};
			}

			return true;
		},
		meta: {
			title: "Session",
			parentName: "ReservationPlannerSessions"
		},
		children: [
			{
				path: "conflicts",
				component() {
					return import("../ReservationPlannerSession/components/ConflictsTab.vue");
				}
			},
			{
				path: "changed",
				component() {
					return import("../ReservationPlannerSession/components/ChangedTab.vue");
				}
			},
			{
				path: "unchanged",
				component() {
					return import("../ReservationPlannerSession/components/UnchangedTab.vue");
				}
			},
			{
				path: "rejected",
				component() {
					return import("../ReservationPlannerSession/components/RejectedTab.vue");
				}
			}
		]
	}
];
